import {
  PreferredShippingMethodBuildArgs
} from './preferred-shipping-method-yesterday.strategy';

export const todayPreferredShippingMethodOptions = [
  { name: 'Flat Rate', code: 'flat' },
  { name: 'Free Shipping', code: 'free' },
  { name: 'Calculated Rates', code: 'calc' }
];

const ALL_USPS_SERVICES = [
  'express_mail',
  'priority_mail',
  'first_class',
  'ground_advantage',
  'standard_post',
  'media_mail',
  'library_mail'
];

export function buildTodayPreferredShippingConfiguration(
  args: PreferredShippingMethodBuildArgs
): any {
  const {
    rateType,
    businessCountry,
    businessState,
    businessZipCode,
    businessCity,
    businessPhone,
    businessStreetAddress,
    setup,
    usStates,
    locationOverride,
    existingZones,
    normalizeString,
    sanitizeZipCode
  } = args;

  const allUsStateCodes = usStates
    .map((state: any) => String(state?.code || '').trim())
    .filter((code: string) => code.length > 0);
  const country = businessCountry || normalizeString(setup?.country) || 'US';
  const state =
    normalizeString(locationOverride?.state)
    || businessState
    || normalizeString(setup?.state);
  const zipCode = sanitizeZipCode(businessZipCode || setup?.zip || '');
  const city =
    normalizeString(locationOverride?.city)
    || businessCity
    || normalizeString(setup?.city);
  const phone = String(businessPhone || normalizeString(setup?.phone) || '').replace(/\D/g, '');
  const addressSource = businessStreetAddress || normalizeString(setup?.address);
  const address = addressSource.includes('||')
    ? normalizeString(addressSource.split('||')[0])
    : addressSource;
  const states = {
    USA: allUsStateCodes
  };
  const defaultUspsServices = rateType === 'calc' || rateType === 'free'
    ? ALL_USPS_SERVICES
    : [];
  const shippingType = rateType === 'flat' ? 1 : rateType === 'free' ? 2 : 3;
  const normalizedExistingZones = Array.isArray(existingZones) && existingZones.length > 0
    ? existingZones
    : [null];

  return {
    zones: normalizedExistingZones.map((existingZone: any) => {
      const timestamp = new Date().toISOString();
      const zoneId = existingZone?.id || String(Date.now());
      const nestedEntityId = existingZone?.flatRate?.id
        || existingZone?.storePickUp?.id
        || existingZone?.usps?.id
        || zoneId;

      return {
        id: zoneId,
        CreatedDate: existingZone?.CreatedDate || existingZone?.createdDate || timestamp,
        isEnabled: true,
        zoneName: existingZone?.zoneName || 'Default Zone',
        shippingtype: shippingType,
        country,
        address,
        phone,
        city,
        countries: existingZone?.countries?.length ? existingZone.countries : ['USA'],
        zipCode,
        state,
        states: existingZone?.states && Object.keys(existingZone.states).length > 0 ? existingZone.states : states,
        isSaved: true,
        flatRate: {
          isEnableFlat: rateType === 'flat',
          rate: 0,
          isTaxIncluded: true,
          taxRate: 0,
          id: existingZone?.flatRate?.id || nestedEntityId,
          updatedAt: existingZone?.flatRate?.updatedAt || timestamp
        },
        storePickUp: {
          isEnablePickup: rateType === 'calc' || rateType === 'free',
          pickupCost: 0,
          isTaxIncluded: true,
          taxRate: 0,
          id: existingZone?.storePickUp?.id || nestedEntityId,
          updatedAt: existingZone?.storePickUp?.updatedAt || timestamp
        },
        usps: {
          isEnabledUsps: rateType === 'calc',
          postcode: zipCode,
          enabledServices: defaultUspsServices,
          id: existingZone?.usps?.id || nestedEntityId,
          userID: existingZone?.usps?.userID || '891000005749',
          updatedAt: existingZone?.usps?.updatedAt || timestamp
        }
      };
    })
  };
}

export function normalizeTodayPreferredShippingProvider(
  value: any,
  normalizeString: (value: any) => string
): string {
  const normalizedValue = normalizeString(value).toLowerCase();

  if (!normalizedValue) {
    return '';
  }

  if (
    normalizedValue === 'flat'
    || normalizedValue === 'flat rate'
  ) {
    return 'flat';
  }

  if (
    normalizedValue === 'free'
    || normalizedValue === 'free shipping'
  ) {
    return 'free';
  }

  if (
    normalizedValue === 'calc'
    || normalizedValue === 'calculated rates'
    || normalizedValue === 'calculated rate'
    || normalizedValue === 'calculated'
    || normalizedValue === 'usps'
  ) {
    return 'calc';
  }

  return '';
}
